module.exports = __webpack_public_path__ + "img/fiturPelatihan.0484f2a9.png";